import React from 'react'

const Tools = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Tools</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bxl-wordpress"></i>

                    <div>
                        <h3 className="skills__name">WordPress</h3>
                        <span className="skills__level">Advance</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bxl-shopify"></i>

                    <div>
                        <h3 className="skills__name">Shopify</h3>
                        <span className="skills__level">Advance</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bxl-docker"></i>

                    <div>
                        <h3 className="skills__name">Docker</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bxl-figma"></i>

                    <div>
                        <h3 className="skills__name">Figma</h3>
                        <span className="skills__level">Advance</span>
                    </div>
                </div>

            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bxl-adobe"></i>

                    <div>
                        <h3 className="skills__name">Adobe XD</h3>
                        <span className="skills__level">Advance</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bxl-github"></i>

                    <div>
                        <h3 className="skills__name">Github</h3>
                        <span className="skills__level">Advance</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bxl-git"></i>

                    <div>
                        <h3 className="skills__name">Bitbucket</h3>
                        <span className="skills__level">Adanvce</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-code"></i>

                    <div>
                        <h3 className="skills__name">VS Code</h3>
                        <span className="skills__level">Adanvce</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Tools